(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[740],{

/***/ 42309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ah": function() { return /* reexport */ es_Close; },
  "BJ": function() { return /* reexport */ Dialog; },
  "XE": function() { return /* reexport */ Mask; },
  "Te": function() { return /* reexport */ Modal; }
});

// UNUSED EXPORTS: NuPortal

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/@_nu/react-dialog/es/Modal/useLockScroll.js


var useLockScroll = function useLockScroll(enabled) {
  if (typeof document === 'undefined') {
    return null;
  } // 滚动的元素


  var scrollEle = document.scrollingElement ? document.scrollingElement : document.documentElement; // 滚动元素滚动条宽度

  var scrollWidth = window.innerWidth - scrollEle.clientWidth;
  var styleOrigin = {}; // 锁定滚动条

  var lock = function lock() {
    var _window$getComputedSt = window.getComputedStyle(scrollEle),
        overflow = _window$getComputedSt.overflow,
        borderRight = _window$getComputedSt.borderRight;

    styleOrigin = {
      overflow: overflow,
      borderRight: borderRight
    };
    scrollEle.style.overflow = 'hidden';
    scrollEle.style.borderRight = "".concat(scrollWidth, " solid transparent");
  }; // 解锁滚动条


  var unlock = function unlock() {
    scrollEle.style.overflow = styleOrigin.overflow;
    scrollEle.style.borderRight = styleOrigin.borderRight;
  };

  (0,react.useEffect)(function () {
    // didUpdate 的时候切换滚动条
    enabled ? lock() : unlock();
    return function () {
      // unmount 的时候切换滚动条
      unlock();
    };
  }, [enabled]);
  return null;
};

/* harmony default export */ var Modal_useLockScroll = (useLockScroll);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@_nu/react-dialog/es/Portal/getElementById.js
/**
 * 获取元素Id
 * @param id
 * @returns {HTMLElement|null|HTMLDivElement}
 */
function getElementById(id) {
  if (!id || !document) {
    return null;
  }

  var domRoot = document.getElementById(id);

  if (domRoot) {
    return domRoot;
  }

  var newRoot = document.createElement('div');
  newRoot.id = id;
  document.body.appendChild(newRoot);
  return newRoot;
}

/* harmony default export */ var Portal_getElementById = (getElementById);
;// CONCATENATED MODULE: ./node_modules/@_nu/react-dialog/es/Portal/index.js
// import React from 'react';




function NuPortal(_ref) {
  var _ref$root = _ref.root,
      root = _ref$root === void 0 ? document ? document.body : null : _ref$root,
      children = _ref.children;

  if (!root || typeof document === 'undefined') {
    return children;
  }

  var container = Portal_getElementById(root) || document.body;
  return /*#__PURE__*/react_dom.createPortal(children, container);
}

NuPortal.propTypes = {
  root: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).element, prop_types_default().oneOf([false])]),
  children: (prop_types_default()).node
};
/* harmony default export */ var Portal = (NuPortal);
;// CONCATENATED MODULE: ./node_modules/@_nu/react-dialog/es/Modal/index.js
var _excluded = ["className", "children", "open", "lockScroll", "removeTime", "root", "Component", "forceRender"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Author: ziven27
 * Date: 8/15/2020
 * Desc: 弹窗组件
 */




/**
 * 弹层组件
 * @param className
 * @param children
 * @param open
 * @param lockScroll
 * @param removeTime
 * @param root
 * @param onClose
 * @param Component
 * @param otherProps
 * @param ref
 * @returns {JSX.Element|null}
 * @constructor
 */

var NuModal = /*#__PURE__*/react.forwardRef(function NuModal(_ref, ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'nu_modal' : _ref$className,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$lockScroll = _ref.lockScroll,
      lockScroll = _ref$lockScroll === void 0 ? true : _ref$lockScroll,
      _ref$removeTime = _ref.removeTime,
      removeTime = _ref$removeTime === void 0 ? 200 : _ref$removeTime,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? 'nuModal' : _ref$root,
      _ref$Component = _ref.Component,
      Component = _ref$Component === void 0 ? 'dialog' : _ref$Component,
      _ref$forceRender = _ref.forceRender,
      forceRender = _ref$forceRender === void 0 ? false : _ref$forceRender,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  // is render in dom
  var _useState = (0,react.useState)(forceRender),
      _useState2 = _slicedToArray(_useState, 2),
      exit = _useState2[0],
      setExit = _useState2[1]; // is visible


  var _useState3 = (0,react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      show = _useState4[0],
      setShow = _useState4[1];

  (0,react.useEffect)(function () {
    var removeTimer;

    if (open) {
      setExit(true);
      /**
       *  After exit and add attr `open` to dialog
       *  Fot the css transition
       */

      setTimeout(function () {
        setShow(true);
      }, 16);
    } else {
      setShow(null); // remove dialog by removeTime

      if (removeTime > 0) {
        // hide dialog and remove dialog after removeTime
        removeTimer = setTimeout(function () {
          !forceRender && setExit(false);
        }, removeTime);
      } else if (removeTime === 0) {
        // remove dialog immediately
        !forceRender && setExit(false);
      } else {// keep exit after hide
      }
    }

    return function () {
      // eslint-disable-next-line no-unused-expressions
      removeTimer && clearTimeout(removeTimer);
    };
  }, [open, removeTime, forceRender]);
  /**
   * if `true` lock the scroll when open
   */

  Modal_useLockScroll(lockScroll && open);
  /**
   * is not exit remote the dom
   */

  if (!exit) {
    return null;
  }

  return /*#__PURE__*/react.createElement(Portal, {
    root: root
  }, /*#__PURE__*/react.createElement(Component, _extends({
    ref: ref,
    open: show,
    tabIndex: "0",
    role: "dialog",
    className: className
  }, otherProps), children));
});
NuModal.defaultProps = {};
NuModal.propTypes = {
  /**
   * css class
   */
  className: (prop_types_default()).string,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: (prop_types_default()).node,

  /**
   * if `> 0`, hide dialog and remove dialog after removeTime
   * else if `0`, remove dialog immediately
   * else, keep exit after hide
   */
  removeTime: (prop_types_default()).number,

  /**
   * If `true`, the dialog go through the enter, entring, enterd.
   * If `false`, the dialog go through the exitring, exitred.
   */
  open: (prop_types_default()).bool,

  /**
   * If `true`, when dialog scroll into bottom the body will scroll
   */
  lockScroll: (prop_types_default()).bool,

  /**
   * All the modal will render into this dom
   * If `false`, modal will not use portal
   */
  root: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).element, prop_types_default().oneOf([false])]),

  /**
   * Components of modal
   */
  Component: (prop_types_default()).node,

  /**
   * If `true`, the dialog will render when mount
   */
  forceRender: (prop_types_default()).bool
};
/* harmony default export */ var Modal = (NuModal);
;// CONCATENATED MODULE: ./node_modules/@_nu/react-dialog/es/Mask/index.js
var Mask_excluded = ["className", "title"];

function Mask_extends() { Mask_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Mask_extends.apply(this, arguments); }

function Mask_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Mask_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Mask_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



/**
 * 遮罩组件
 * @param className
 * @param title
 * @param otherProps
 * @returns {JSX.Element}
 * @constructor
 */

var NuMask = function NuMask(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'nu_mask' : _ref$className,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Mask' : _ref$title,
      otherProps = Mask_objectWithoutProperties(_ref, Mask_excluded);

  return /*#__PURE__*/react.createElement("button", Mask_extends({
    className: className,
    type: "button",
    title: title,
    "aria-label": title
  }, otherProps));
};

NuMask.propTypes = {
  className: (prop_types_default()).string,
  title: (prop_types_default()).string
};
/* harmony default export */ var Mask = (NuMask);
;// CONCATENATED MODULE: ./node_modules/@_nu/react-dialog/es/Dialog/index.js
var Dialog_excluded = ["className", "role"];

function Dialog_extends() { Dialog_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Dialog_extends.apply(this, arguments); }

function Dialog_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Dialog_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Dialog_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var NuDialog = function NuDialog(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'nu_dialog' : _ref$className,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'document' : _ref$role,
      otherProps = Dialog_objectWithoutProperties(_ref, Dialog_excluded);

  return /*#__PURE__*/react.createElement("section", Dialog_extends({
    role: role,
    className: className
  }, otherProps));
};

NuDialog.propTypes = {
  /**
   * css class
   */
  className: (prop_types_default()).string,

  /**
   * children
   */
  children: (prop_types_default()).node,

  /**
   * role of dialog
   */
  role: (prop_types_default()).string
};
/* harmony default export */ var Dialog = (NuDialog);
;// CONCATENATED MODULE: ./node_modules/@_nu/react-dialog/es/Close/index.js
var Close_excluded = ["className", "children", "title"];

function Close_extends() { Close_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Close_extends.apply(this, arguments); }

function Close_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Close_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function Close_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Close = function Close(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? /*#__PURE__*/react.createElement(react.Fragment, null, "\xD7") : _ref$children,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Close' : _ref$title,
      otherProps = Close_objectWithoutProperties(_ref, Close_excluded);

  return /*#__PURE__*/react.createElement("button", Close_extends({
    "aria-label": title,
    type: "button",
    className: "nu_dialog_close ".concat(className),
    title: title,
    tabIndex: 0
  }, otherProps), children);
};

Close.propTypes = {
  /**
   * css class
   */
  className: (prop_types_default()).string,

  /**
   * title
   */
  title: (prop_types_default()).string,

  /**
   * children
   */
  children: (prop_types_default()).node
};
/* harmony default export */ var es_Close = (Close);
;// CONCATENATED MODULE: ./node_modules/@_nu/react-dialog/es/index.js
/**
 * Author: ziven27
 * Date: 8/15/2020
 * Desc: 弹窗组件
 */






/***/ }),

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _loadableContext = __webpack_require__(33644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ })

}]);